import React, { useState, useEffect } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import MainFeaturedPost from "./MainFeaturedPost";
import FeaturedPost from "./FeaturedPost";
import JobOffers from "./JobOffers";
import Advertisement from "./Advertisement";
import JobCompanies from "./JobCompanies";
import Workfromhome from "./Workfromhome";
import Advertisement2 from "./Advertisement2";
import Companylogo from "./Companylogo";
import { axiosAPI } from "../Axios/Axios";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { warningNotify } from "../CommonCode/Commonfunc";
import video from "../../Images/Msquared-Training.mp4";
import img1 from "../../Images/las1.jpg";
import img2 from "../../Images/las2.jpg";
import "./Style.css";
import { getAllList } from "../../redux/getListSlice";
import { getProfanityWord } from "../../redux/Profanity";
import MostSearchedJobs from "./MostSearchedJobs";
import DesiredIndustry from "./DesiredIndustry";
import Search from "./Search";
import teamImage from "../../Images/Narajo_Landing_page_04.webp";
import buildingImage from "../../Images/Narajo_Landing_page_05.webp";
import candidateImage from "../../Images/Narajo_Landing_page_06.webp";

const Landingpage_1 = () => {
  const redirect = useNavigate();
  const dispatch = useDispatch();
  const defaultTheme = createTheme();
  const allList = useSelector((state) => state.allList.list);
  const Labels = useSelector((state) => state.allLabels.labels);
  const [selectedIndustryId, setSelectedIndustryId] = useState(0);
  const [desiredIndustryJobs, setDesiredIndustryJobs] = useState([]);
  const [isIndustryLoading, setIsIndustryLoading] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("sessionTimeoutNotified")) {
      warningNotify(Labels?.sessionTimeout);
      localStorage.removeItem("sessionTimeoutNotified");
    }
  }, []);

  const getList = () => {
    dispatch(getAllList());
  };
  
  useEffect(() => {
    getList();
  }, [Labels]);

  const featuredJobs = [
    "Housekeeping Attendant",
    "Desert Details Tr.",
    "Security Officer JCH",
    "Hotel Head Chef JCH",
    "Hospitality Service",
    "Front Desk Agent",
  ];

  const industryCategories = allList?.businessCategory?.slice(0, 7) || [];
  const hiddenIndustryCount = Math.max((allList?.businessCategory?.length || 0) - 7, 0);
  const industries = [
    { id: 0, name: Labels?.All || "All" },
    ...industryCategories,
  ];
  const fallbackCompanies = [
    { id: "paramount", name: "Paramount", description: "We help match talented people with career opportunities.", state: "Kerala", jobs: 0 },
    { id: "m2", name: "M2 Tower Of Care", description: "We help match talented people with career opportunities.", state: "Kerala", jobs: 0 },
    { id: "masquared", name: "Masquared", description: "We help match talented people with career opportunities.", state: "Kerala", jobs: 0 },
    { id: "teleportance", name: "Teleportance", description: "We help match talented people with career opportunities.", state: "Kerala", jobs: 0 },
  ];
  const topCompanies = allList?.companies?.length
    ? allList.companies.slice(0, 4)
    : fallbackCompanies;

  useEffect(() => {
    if (selectedIndustryId === 0) {
      setDesiredIndustryJobs(allList?.industryBasedJobs || []);
    }
  }, [allList, selectedIndustryId]);

  const handleIndustrySwitch = async (industry) => {
    setSelectedIndustryId(industry.id);

    if (industry.id === 0) {
      setDesiredIndustryJobs(allList?.industryBasedJobs || []);
      return;
    }

    setIsIndustryLoading(true);
    try {
      const result = await axiosAPI.post("/desiredIndustryJobs", {
        category: industry.id,
      });
      const { status, success, data } = result.data;
      setDesiredIndustryJobs(status || success ? data || [] : []);
    } catch (error) {
      setDesiredIndustryJobs([]);
    } finally {
      setIsIndustryLoading(false);
    }
  };

  const viewAllIndustries = () => {
    redirect("/jobSearchPrelogin", {
      state: {
        city: "",
        isMoreIndustry: true,
      },
    });
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      <Container
        maxWidth="100%"
        sx={{ margin: "0 auto", padding: "0 !important" }}
      >
        {/* -----------------------Banner------------------------ */}
        <MainFeaturedPost />
        <Container maxWidth="lg" className="narajoLandingBody">
          <Paper elevation={0}>
            <Box className="narajoSection">
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography className="narajoSectionTitle">
                  Featured <Box component="span">Jobs</Box>
                </Typography>
                <Button className="narajoViewAll" endIcon={<ArrowForwardIcon />}>View All</Button>
              </Stack>
              <Grid container spacing={4} alignItems="center">
                <Grid item xs={12} md={6}>
                  <Grid container spacing={2}>
                    {featuredJobs.map((job, index) => (
                      <Grid item xs={12} sm={6} key={job}>
                        <Card className="narajoJobCard" elevation={0}>
                          <CardContent>
                            <Typography className="narajoJobTitle">{job}</Typography>
                            <Typography className="narajoJobMeta">Approx vacancy</Typography>
                            <Typography className="narajoJobLocation">Cost Rica</Typography>
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box component="img" src={teamImage} alt="Recruiters reviewing candidate details" className="narajoFeatureImage" />
                </Grid>
              </Grid>
            </Box>

            <Box className="narajoSection compact">
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography className="narajoSectionTitle">
                  Desired <Box component="span">Industry</Box>
                </Typography>
                <Button
                  className="narajoViewAll"
                  endIcon={<ArrowForwardIcon />}
                  onClick={viewAllIndustries}
                >
                  View All
                </Button>
              </Stack>
              <Stack direction="row" className="narajoIndustryChips">
                {industries.map((industry) => (
                  <Chip
                    key={industry.id}
                    label={industry.name}
                    className={industry.id === selectedIndustryId ? "active" : ""}
                    onClick={() => handleIndustrySwitch(industry)}
                    clickable
                  />
                ))}
                {hiddenIndustryCount > 0 && (
                  <Chip
                    label={`+${hiddenIndustryCount} ${Labels?.More || "More"}`}
                    onClick={viewAllIndustries}
                    clickable
                  />
                )}
              </Stack>
              <Typography className="narajoVacancyCount">
                {isIndustryLoading
                  ? "Loading..."
                  : `${desiredIndustryJobs.length} Jobs Available`}
              </Typography>
            </Box>

            <Box className="narajoSection">
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography className="narajoSectionTitle">
                  Jobs From <Box component="span">Top Companies</Box>
                </Typography>
                <Button className="narajoViewAll" endIcon={<ArrowForwardIcon />} onClick={() => redirect("/jobSearchPrelogin")}>
                  View All
                </Button>
              </Stack>
              <Grid container spacing={4} alignItems="center">
                <Grid item xs={12} md={5}>
                  <Box component="img" src={buildingImage} alt="Office buildings" className="narajoBuildingImage" />
                </Grid>
                <Grid item xs={12} md={7}>
                  <Grid container spacing={2}>
                    {topCompanies.map((company) => (
                      <Grid item xs={12} sm={6} key={company.id || company.name}>
                        <Card
                          className="narajoCompanyCard"
                          elevation={0}
                          onClick={() => company.id && redirect(`/company/${company.id}`)}
                        >
                          <CardContent>
                            <Avatar
                              src={company.logo || ""}
                              alt={company.name || "Company logo"}
                              className="narajoCompanyLogo"
                            >
                              {(company.name || "C").charAt(0)}
                            </Avatar>
                            <Typography className="narajoCompanyName">{company.name}</Typography>
                            <Typography className="narajoCompanyText">
                              {company.description || "We help match talented people with career opportunities."}
                            </Typography>
                            <Box className="narajoCompanyFooter">
                              <Typography className="narajoJobLocation">{company.state || "Kerala"}</Typography>
                              <Typography className="narajoCompanyPosition">
                                {company.jobs || 0} Position Available
                              </Typography>
                            </Box>
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              </Grid>
            </Box>

            <Box className="narajoSection dream">
              <Grid container spacing={5} alignItems="center">
                <Grid item xs={12} md={6}>
                  <Typography className="narajoSectionTitle">
                    Find Your Dream <Box component="span">Job</Box> <br /> in one place
                  </Typography>
                  <Typography className="narajoParagraph">
                    Discover your ideal job with ease. Whether you're just starting your career or looking to take the next step, our platform brings together thousands of opportunities tailored to your skills and ambitions. Let us help you find the perfect match in just one place. With personalized job recommendations and advanced search features, you'll connect with top employers who value your unique talents. Start your journey towards a fulfilling career today-your dream job is waiting!
                  </Typography>
                  <Stack direction="row" spacing={2} className="narajoCompanyButtons">
                    <Button>Company 1</Button>
                    <Button>Company 2</Button>
                    <Button>Company 3</Button>
                  </Stack>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box component="img" src={candidateImage} alt="Candidate going to work" className="narajoDreamImage" />
                </Grid>
              </Grid>
            </Box>

            <Box className="narajoAdvertise">
              <Box>
                <Typography className="narajoAdvertiseTitle">Advertise your brand</Typography>
                <Typography className="narajoAdvertiseText">
                  Keep Your Head Up, Your Dreams High. Join Our Team Today! End Hunger, End Unemployment, Apply And Work Today! No Job, No Problem.
                </Typography>
              </Box>
              <Button onClick={() => redirect("/contact")}>Call Us Now</Button>
            </Box>
          </Paper>
        </Container>
        <Footer />
      </Container>
    </ThemeProvider>
  );
};

export default Landingpage_1;
